class BaseUrl {
  constructor() {
    this.SERVERURL = "";
    // Release: https://my.i-theses.com, Test: https://test-my.i-theses.com, localhost: http://localhost:80
    this.BROWSERURL = "/";
    // Release: https://my.i-theses.com, Test: https://test-my.i-theses.com, localhost: http://localhost:3000
  }
}

export default BaseUrl;



// WEBPACK FOOTER //
// ./src/Stores/DataStore/Enums/BaseUrl.js